// import React, { useEffect, useState } from 'react';
// import {
//   Box, Button, Dialog, DialogActions, DialogContent,
//   DialogTitle, IconButton, TextField, Typography,
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   Paper, Grid, Snackbar, LinearProgress, Stack,
//   Alert, Card, CardHeader, CardContent, Tooltip
// } from '@mui/material';
// import { Add, Edit, Delete, HelpOutline } from '@mui/icons-material';
// import axios from '../../Axiosinstance';

// const FeedbackManager = () => {
//   const [feedbacks, setFeedbacks] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [editingFeedback, setEditingFeedback] = useState(null);
//   const [questionText, setQuestion] = useState('');
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchFeedbacks = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get('/feedback-questions');
//       setFeedbacks(res.data);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//       showSnackbar('Failed to fetch questions', 'error');
//     }
//   };

//   useEffect(() => {
//     fetchFeedbacks();
//   }, []);

//   const handleOpen = (feedback = null) => {
//     setEditingFeedback(feedback);
//     setQuestion(feedback ? feedback.questionText : '');
//     setOpen(true);
//   };

//   const showSnackbar = (message, severity = 'success') => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbarOpen(false);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setEditingFeedback(null);
//     setQuestion('');
//   };

//   const handleSubmit = async () => {
//     try {
//       if (editingFeedback) {
//         await axios.put(`/feedback-questions/${editingFeedback.id}`, { questionText });
//         showSnackbar('Question updated successfully');
//       } else {
//         await axios.post('/feedback-questions', { questionText });
//         showSnackbar('Question created successfully');
//       }
//       handleClose();
//       fetchFeedbacks();
//     } catch (err) {
//       showSnackbar(`Failed to ${editingFeedback ? 'update' : 'create'} questionText`, 'error');
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`/feedback-questions/${id}`);
//       showSnackbar('Question deleted successfully');
//       fetchFeedbacks();
//     } catch (err) {
//       showSnackbar('Failed to delete question', 'error');
//     }
//   };

//   return (
//    <Box sx={{ maxWidth: '850px', mx: 'auto', p: 2,marginTop:'3%'}}>
//       <Card  sx={{ borderRadius: 2 }}>
//         <CardHeader
//           title="Feedback Questions Management"
//           subheader="Create and manage feedback questions for your application"
//           action={
//             <Button
//               variant="contained"
//               startIcon={<Add />}
//               onClick={() => handleOpen()}
//               sx={{ 
//                 backgroundColor: 'primary.main',
//                 '&:hover': { backgroundColor: 'primary.dark' }
//               }}
//             >
//               Add Question
//             </Button>
//           }
//           sx={{
//             borderBottom: '1px solid',
//             borderColor: 'divider',
//             backgroundColor: 'background.paper'
//           }}
//         />
        
//         <CardContent>
//           {loading && <LinearProgress sx={{ mb: 2 }} />}
          
//           {error && (
//             <Alert severity="error" sx={{ mb: 3 }}>
//               {error}
//             </Alert>
//           )}
          
//           <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 1 }}>
//             <Table>
//               <TableHead sx={{ backgroundColor: 'background.default' }}>
//                 <TableRow>
//                   <TableCell sx={{ fontWeight: 'bold' }}>S.No</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>Question</TableCell>
//                   <TableCell align="right" sx={{ fontWeight: 'bold' }}>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {feedbacks.map((fb, index) => (
//                   <TableRow 
//                     key={fb.id}
//                     hover
//                     sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//                   >
//                     <TableCell>{index + 1}</TableCell>
//                     <TableCell>{fb.questionText}</TableCell>
//                     <TableCell align="right">
//                       <Tooltip title="Edit">
//                         <IconButton 
//                           onClick={() => handleOpen(fb)}
//                           color="primary"
//                           sx={{ '&:hover': { backgroundColor: 'primary.light' } }}
//                         >
//                           <Edit />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Delete">
//                         <IconButton 
//                           onClick={() => handleDelete(fb.id)}
//                           color="error"
//                           sx={{ '&:hover': { backgroundColor: 'error.light' } }}
//                         >
//                           <Delete />
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//                 {!loading && feedbacks.length === 0 && (
//                   <TableRow>
//                     <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
//                       <Stack alignItems="center" spacing={1}>
//                         <HelpOutline color="disabled" sx={{ fontSize: 40 }} />
//                         <Typography color="text.secondary">
//                           No feedback questions found
//                         </Typography>
//                         <Button 
//                           variant="outlined" 
//                           onClick={() => handleOpen()}
//                           sx={{ mt: 1 }}
//                         >
//                           Create your first question
//                         </Button>
//                       </Stack>
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>

//       {/* Dialog for Create/Edit */}
//       <Dialog 
//         open={open} 
//         onClose={handleClose} 
//         fullWidth 
//         maxWidth="sm"
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: 'primary.main', 
//           color: 'primary.contrastText',
//           fontWeight: 'bold'
//         }}>
//           {editingFeedback ? 'Edit Question' : 'Create New Question'}
//         </DialogTitle>
//         <DialogContent sx={{ py: 3 }}>
//           <TextField
//             fullWidth
//             label="Feedback Question"
//             value={questionText}
//             onChange={(e) => setQuestion(e.target.value)}
//             margin="normal"
//             variant="outlined"
//             multiline
//             rows={3}
//             sx={{ mb: 2 }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, py: 2 }}>
//           <Button 
//             onClick={handleClose}
//             variant="outlined"
//             sx={{ mr: 2 }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleSubmit} 
//             variant="contained"
//             disabled={!questionText.trim()}
//           >
//             {editingFeedback ? 'Update Question' : 'Create Question'}
//           </Button>
//         </DialogActions>
//       </Dialog>
      
//       {/* Snackbar for notifications */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={1500}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbarSeverity}
//           variant="filled"
//           sx={{ width: '100%' }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default FeedbackManager;


import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, TextField, Typography, Table, TableBody, TableCell,
  TableHead, TableRow, Paper, Snackbar, LinearProgress,
  Stack, Alert, Tooltip, MenuItem, Select, FormControl,
  InputLabel, Chip, FormControlLabel, Switch, Avatar,
  CircularProgress, InputAdornment, Skeleton,
} from '@mui/material';
import {
  Add, Edit, Delete, Refresh, AddCircleOutline, RemoveCircleOutline,
  SearchOutlined, CloseOutlined, CheckCircleOutlined, FeedbackOutlined,
  QuizOutlined, TextFieldsOutlined, PersonOutlined, FilterAltOutlined,
  VisibilityOutlined, BarChartOutlined, FormatListBulletedOutlined,
  LayersOutlined, AssignmentOutlined, BusinessOutlined, CalendarTodayOutlined,
  SaveOutlined, WarningAmberOutlined, LockOutlined,
} from '@mui/icons-material';
import axios from '../../Axiosinstance';

const FontLink = () => (
  <style>{`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');`}</style>
);

const T = {
  indigo:  { 50: '#EEF2FF', 100: '#E0E7FF', 200: '#C7D2FE', 400: '#818CF8', 600: '#4F46E5', 800: '#3730A3', 900: '#312E81' },
  emerald: { 50: '#ECFDF5', 100: '#D1FAE5', 200: '#A7F3D0', 400: '#34D399', 600: '#059669', 800: '#065F46' },
  amber:   { 50: '#FFFBEB', 100: '#FEF3C7', 200: '#FDE68A', 400: '#FBBF24', 600: '#D97706', 800: '#92400E' },
  rose:    { 50: '#FFF1F2', 100: '#FFE4E6', 400: '#FB7185', 600: '#E11D48', 800: '#9F1239' },
  violet:  { 50: '#F5F3FF', 100: '#EDE9FE', 200: '#DDD6FE', 400: '#A78BFA', 600: '#7C3AED', 800: '#5B21B6' },
  slate:   { 50: '#F8FAFC', 100: '#F1F5F9', 200: '#E2E8F0', 300: '#CBD5E1', 400: '#94A3B8', 500: '#64748B', 600: '#475569', 700: '#334155', 800: '#1E293B', 900: '#0F172A' },
};

const typeConfig = {
  MODULE: { bg: T.indigo[50],  border: T.indigo[200],  text: T.indigo[800],  dot: T.indigo[600],  label: 'Module'  },
  COURSE: { bg: T.emerald[50], border: T.emerald[200], text: T.emerald[800], dot: T.emerald[600], label: 'Course'  },
  ALUMNI: { bg: T.amber[50],   border: T.amber[200],   text: T.amber[800],   dot: T.amber[600],   label: 'Alumni'  },
};

const qtConfig = {
  MCQ:  { bg: T.indigo[50],  text: T.indigo[800],  border: T.indigo[200]  },
  TEXT: { bg: T.emerald[50], text: T.emerald[800], border: T.emerald[200] },
};

const QUESTION_TYPES = ['MCQ', 'TEXT'];

const emptyQ = () => ({
  _key: Math.random(),
  questionText: '', questionType: 'TEXT',
  required: true, mcqOptions: [], _newOption: '',
  _isNew: true,
});

const parseMcq  = (raw) => { try { return raw ? (Array.isArray(raw) ? raw : JSON.parse(raw)) : []; } catch { return []; } };
const fmtDate   = (s)   => s ? new Date(s).toLocaleString('en-SG', { dateStyle: 'medium', timeStyle: 'short' }) : '—';
const initials  = (n = '') => n.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';
const avatarBg  = (n = '') => {
  const cols = ['#4F46E5', '#059669', '#D97706', '#E11D48', '#7C3AED', '#0284C7'];
  let h = 0; for (const c of n) h = c.charCodeAt(0) + ((h << 5) - h);
  return cols[Math.abs(h) % cols.length];
};

/* ─── Micro-components ────────────────────────────────────────────────────── */
const TypePill = ({ type }) => {
  const c = typeConfig[type] || { bg: T.slate[100], border: T.slate[300], text: T.slate[700], dot: T.slate[400], label: type };
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: .5, px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 700, border: `1px solid ${c.border}`, bgcolor: c.bg, color: c.text, whiteSpace: 'nowrap' }}>
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: c.dot, flexShrink: 0 }} />
      {c.label || type}
    </Box>
  );
};

const QtPill = ({ type }) => {
  const c = qtConfig[type] || { bg: T.slate[100], text: T.slate[700], border: T.slate[300] };
  const Icon = type === 'MCQ' ? QuizOutlined : TextFieldsOutlined;
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: .5, px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 700, bgcolor: c.bg, color: c.text, border: `1px solid ${c.border}` }}>
      <Icon sx={{ fontSize: '11px !important' }} />
      {type}
    </Box>
  );
};

const McqBar = ({ label, count, total }) => {
  const pct = total ? Math.round((count / total) * 100) : 0;
  return (
    <Box sx={{ mb: .875 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: .375 }}>
        <Typography sx={{ fontSize: 12, color: T.slate[600] }}>{label}</Typography>
        <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.indigo[600] }}>{count} ({pct}%)</Typography>
      </Box>
      <Box sx={{ height: 5, borderRadius: 3, bgcolor: T.slate[100], overflow: 'hidden' }}>
        <Box sx={{ height: '100%', width: `${pct}%`, bgcolor: T.indigo[600], borderRadius: 3, transition: 'width .4s ease' }} />
      </Box>
    </Box>
  );
};

const SectionLabel = ({ children, icon: Icon }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: .75, mb: 1.25 }}>
    {Icon && <Icon sx={{ fontSize: 14, color: T.slate[400] }} />}
    <Typography sx={{ fontSize: 11, fontWeight: 800, color: T.slate[400], textTransform: 'uppercase', letterSpacing: .7 }}>
      {children}
    </Typography>
  </Box>
);

/* ─── Locked field badge ──────────────────────────────────────────────────── */
const LockedBadge = () => (
  <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: .5, px: 1, py: .25, borderRadius: '20px', fontSize: 10, fontWeight: 700, bgcolor: T.amber[50], color: T.amber[800], border: `1px solid ${T.amber[200]}` }}>
    <LockOutlined sx={{ fontSize: '10px !important' }} />
    Locked
  </Box>
);

/* ─── Response slide-in panel ─────────────────────────────────────────────── */
const ResponsePanel = ({ entry, questions, feedbackType, onClose }) => (
  <>
    <Box onClick={onClose} sx={{ position: 'fixed', inset: 0, bgcolor: 'rgba(15,23,42,0.45)', zIndex: 1299, backdropFilter: 'blur(2px)' }} />
    <Box sx={{
      position: 'fixed', right: 0, top: 0, bottom: 0,
      width: { xs: '100%', sm: 480 }, bgcolor: 'white', zIndex: 1300,
      display: 'flex', flexDirection: 'column',
      boxShadow: '-8px 0 40px rgba(0,0,0,0.14)',
      animation: 'slideIn .22s cubic-bezier(0.16,1,0.3,1)',
      '@keyframes slideIn': { from: { transform: 'translateX(100%)' }, to: { transform: 'translateX(0)' } },
    }}>
      <Box sx={{ p: 3, borderBottom: `1px solid ${T.slate[200]}`, background: `linear-gradient(135deg, ${T.indigo[50]} 0%, white 60%)` }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography sx={{ fontWeight: 800, fontSize: 15, color: T.slate[900], fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Student Response</Typography>
          <IconButton size="small" onClick={onClose} sx={{ color: T.slate[400] }}><CloseOutlined fontSize="small" /></IconButton>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Avatar sx={{ width: 46, height: 46, bgcolor: avatarBg(entry.studentName), fontSize: 15, fontWeight: 800 }}>
            {initials(entry.studentName)}
          </Avatar>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: 15, color: T.slate[900] }}>{entry.studentName}</Typography>
            <Typography sx={{ fontSize: 12, color: T.slate[400], mt: .25 }}>ID: {entry.studentId} · {entry.intakeId || '—'}</Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, mt: 1.5, flexWrap: 'wrap' }}>
          {feedbackType && <TypePill type={feedbackType} />}
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 600, bgcolor: T.slate[100], color: T.slate[600] }}>
            {fmtDate(entry.submittedAt)}
          </Box>
        </Box>
      </Box>
      <Box sx={{ flex: 1, overflowY: 'auto', p: 2.5 }}>
        <Stack spacing={1.5}>
          {(questions || []).map((q, i) => {
            const ans = entry.answers?.[q.questionId] || entry.answers?.[String(q.questionId)];
            const empty = !ans || !String(ans).trim();
            return (
              <Box key={q.questionId} sx={{ p: 2, borderRadius: '10px', border: `1px solid ${empty ? T.slate[100] : T.slate[200]}`, bgcolor: empty ? T.slate[50] : 'white' }}>
                <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                  <Box sx={{ minWidth: 20, height: 20, borderRadius: '50%', bgcolor: T.indigo[600], color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 800, flexShrink: 0 }}>{i + 1}</Box>
                  <Typography sx={{ fontSize: 12.5, color: T.slate[600], lineHeight: 1.5 }}>{q.questionText}</Typography>
                </Box>
                <Box sx={{ pl: 3.5 }}>
                  <QtPill type={q.questionType} />
                  <Box sx={{ mt: 1 }}>
                    {empty
                      ? <Typography sx={{ fontSize: 12.5, color: T.slate[400], fontStyle: 'italic' }}>No answer</Typography>
                      : q.questionType === 'MCQ'
                        ? <Box component="span" sx={{ display: 'inline-flex', px: 1.5, py: .5, borderRadius: '8px', fontSize: 13, fontWeight: 700, bgcolor: T.indigo[600], color: 'white' }}>{ans}</Box>
                        : <Typography sx={{ fontSize: 13, color: T.slate[800], lineHeight: 1.6 }}>{ans}</Typography>
                    }
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Box>
  </>
);

/* ─── Feedback Form Card ──────────────────────────────────────────────────── */
const FeedbackFormCard = ({ form, isSelected, onClick }) => {
  const ft = form.feedbackType || form.type;
  return (
    <Box onClick={onClick} sx={{
      p: 2, borderRadius: '12px', bgcolor: isSelected ? T.indigo[50] : 'white',
      border: `1.5px solid ${isSelected ? T.indigo[400] : T.slate[200]}`,
      cursor: 'pointer', transition: 'all .18s ease',
      boxShadow: isSelected ? `0 0 0 3px ${T.indigo[100]}` : 'none',
      '&:hover': { borderColor: T.indigo[400], boxShadow: `0 0 0 3px ${T.indigo[50]}` },
    }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.slate[800], mb: .625, lineHeight: 1.4 }} noWrap>
            {form.title}
          </Typography>
          <Box sx={{ display: 'flex', gap: .625, flexWrap: 'wrap' }}>
            <TypePill type={ft} />
            {form.moduleNumber && (
              <Box component="span" sx={{ display: 'inline-flex', px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 700, bgcolor: T.indigo[50], color: T.indigo[800], border: `1px solid ${T.indigo[200]}` }}>
                Module {form.moduleNumber}
              </Box>
            )}
          </Box>
        </Box>
        {isSelected && (
          <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: T.indigo[600], display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <CheckCircleOutlined sx={{ fontSize: 12, color: 'white' }} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

/* ─── Delete Confirm Dialog ───────────────────────────────────────────────── */
const DeleteConfirmDialog = ({ open, formTitle, onConfirm, onCancel, loading }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth
    PaperProps={{ sx: { borderRadius: '16px', fontFamily: 'Plus Jakarta Sans, sans-serif' } }}>
    <DialogTitle sx={{ pb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ width: 38, height: 38, borderRadius: '10px', bgcolor: T.rose[50], display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <WarningAmberOutlined sx={{ color: T.rose[600], fontSize: 20 }} />
        </Box>
        <Typography sx={{ fontWeight: 800, fontSize: 15, color: T.slate[900], fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
          Delete Feedback Form
        </Typography>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ fontSize: 13.5, color: T.slate[600], lineHeight: 1.6 }}>
        Are you sure you want to delete <strong style={{ color: T.slate[900] }}>"{formTitle}"</strong>?
        This action cannot be undone.
      </Typography>
      <Box sx={{ mt: 1.5, p: 1.5, borderRadius: '8px', bgcolor: T.rose[50], border: `1px solid ${T.rose[100]}` }}>
        <Typography sx={{ fontSize: 12, color: T.rose[700] }}>
          ⚠ If any students have already submitted responses, deletion will be blocked.
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button onClick={onCancel} size="small"
        sx={{ textTransform: 'none', fontSize: 13, color: T.slate[600], borderRadius: '8px' }}>
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" size="small" disabled={loading}
        sx={{ textTransform: 'none', fontSize: 13, fontWeight: 700, borderRadius: '8px', bgcolor: T.rose[600], boxShadow: 'none', '&:hover': { bgcolor: T.rose[800], boxShadow: 'none' } }}>
        {loading ? <CircularProgress size={14} sx={{ color: 'white' }} /> : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);

/* ─── Question Row ────────────────────────────────────────────────────────── */
/**
 * isEditMode   — true when editing an existing form
 * row._isNew   — true when this question was added fresh during edit (not from DB)
 *
 * Rules in edit mode for existing questions (_isNew = false):
 *   • questionType  → locked (read-only)
 *   • MCQ options   → can ADD new ones, cannot delete existing ones
 *   • questionText  → editable
 *   • required      → editable
 *   • remove row    → not allowed
 *
 * New questions added during edit (_isNew = true) have no restrictions.
 */
const QuestionRow = ({ row, index, onUpdate, onRemove, showRemove, isEditMode }) => {
  const isLocked = isEditMode && !row._isNew;
  const updateRow = (field, value) => onUpdate(row._key, field, value);

  const addOpt = () => {
    if (!row._newOption.trim()) return;
    updateRow('mcqOptions', [...row.mcqOptions, row._newOption.trim()]);
    updateRow('_newOption', '');
  };

  // In edit mode existing questions: cannot delete existing options
  // new options added in this session can be removed (tracked by _sessionOptions)
  const remOpt = (i) => {
    if (isLocked) {
      // Only allow removing options that were added in this session
      const originalCount = row._originalOptionCount || 0;
      if (i < originalCount) return; // block removing original options
    }
    updateRow('mcqOptions', row.mcqOptions.filter((_, idx) => idx !== i));
  };

  return (
    <Paper elevation={0} sx={{
      p: 2.5, borderRadius: '12px',
      border: `1px solid ${isLocked ? T.amber[200] : T.slate[200]}`,
      bgcolor: isLocked ? T.amber[50] : 'white',
      position: 'relative',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 24, height: 24, borderRadius: '8px', bgcolor: isLocked ? T.amber[600] : T.indigo[600], display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography sx={{ fontSize: 11, fontWeight: 800, color: 'white' }}>{index + 1}</Typography>
          </Box>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.slate[500] }}>Question {index + 1}</Typography>
          {isLocked && <LockedBadge />}
        </Box>
        {/* Only show remove button if: create mode, OR edit mode + question is new */}
        {showRemove && !isLocked && (
          <Tooltip title="Remove question">
            <IconButton size="small" onClick={() => onRemove(row._key)} sx={{ color: T.rose[400], '&:hover': { bgcolor: T.rose[50], color: T.rose[600] } }}>
              <RemoveCircleOutline sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems="flex-start">
        <TextField
          size="small"
          label="Question Text"
          value={row.questionText}
          onChange={e => updateRow('questionText', e.target.value)}
          multiline minRows={1} maxRows={3} required
          sx={{ flex: 3, '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: 13 } }}
        />

        {/* Question type: locked for existing questions in edit mode */}
        {isLocked ? (
          <Box sx={{ width: 110, flexShrink: 0 }}>
            <Typography sx={{ fontSize: 10, fontWeight: 700, color: T.slate[400], mb: .5, textTransform: 'uppercase', letterSpacing: .5 }}>Type</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: .5 }}>
              <QtPill type={row.questionType} />
              <LockOutlined sx={{ fontSize: 12, color: T.amber[600] }} />
            </Box>
          </Box>
        ) : (
          <FormControl size="small" sx={{ width: 110, flexShrink: 0 }}>
            <InputLabel sx={{ fontSize: 13 }}>Type</InputLabel>
            <Select label="Type" value={row.questionType}
              onChange={e => {
                updateRow('questionType', e.target.value);
                if (e.target.value !== 'MCQ') { updateRow('mcqOptions', []); updateRow('_newOption', ''); }
              }}
              sx={{ borderRadius: '8px', fontSize: 13 }}>
              {QUESTION_TYPES.map(t => <MenuItem key={t} value={t} sx={{ fontSize: 13 }}>{t}</MenuItem>)}
            </Select>
          </FormControl>
        )}

        <FormControlLabel
          control={<Switch size="small" checked={row.required} onChange={e => updateRow('required', e.target.checked)} />}
          label={<Typography sx={{ fontSize: 12, color: T.slate[500] }}>Required</Typography>}
          sx={{ flexShrink: 0, ml: 0 }}
        />
      </Stack>

      {row.questionType === 'MCQ' && (
        <Box sx={{ mt: 1.5, p: 1.5, borderRadius: '8px', bgcolor: isLocked ? 'rgba(255,255,255,0.7)' : T.indigo[50], border: `1px solid ${isLocked ? T.amber[200] : T.indigo[200]}` }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Typography sx={{ fontSize: 11, fontWeight: 800, color: isLocked ? T.amber[800] : T.indigo[800], textTransform: 'uppercase', letterSpacing: .5 }}>
              MCQ Options
            </Typography>
            {isLocked && (
              <Typography sx={{ fontSize: 10, color: T.amber[700], fontStyle: 'italic' }}>
                · existing options are locked
              </Typography>
            )}
          </Box>

          {/* Add new option — always allowed */}
          <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
            <TextField
              size="small"
              placeholder="Add new option, press Enter"
              value={row._newOption}
              onChange={e => updateRow('_newOption', e.target.value)}
              onKeyDown={e => e.key === 'Enter' && addOpt()}
              sx={{ flex: 1, '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: 13, bgcolor: 'white' } }}
            />
            <Button size="small" variant="contained" onClick={addOpt} disabled={!row._newOption.trim()}
              sx={{ borderRadius: '8px', textTransform: 'none', fontSize: 12, bgcolor: isLocked ? T.amber[600] : T.indigo[600], boxShadow: 'none', px: 2, '&:hover': { bgcolor: isLocked ? T.amber[800] : T.indigo[800], boxShadow: 'none' } }}>
              Add
            </Button>
          </Stack>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: .75 }}>
            {row.mcqOptions.map((opt, i) => {
              const isOriginal = isLocked && i < (row._originalOptionCount || 0);
              return (
                <Box key={i} sx={{
                  display: 'inline-flex', alignItems: 'center', gap: .5,
                  px: 1.25, py: .375, borderRadius: '8px',
                  bgcolor: isOriginal ? T.slate[100] : 'white',
                  border: `1px solid ${isOriginal ? T.slate[300] : T.indigo[200]}`,
                  fontSize: 12, fontWeight: 700,
                  color: isOriginal ? T.slate[600] : T.indigo[800],
                }}>
                  {isOriginal && <LockOutlined sx={{ fontSize: 10, color: T.slate[400] }} />}
                  {opt}
                  {/* Only show X for new options added this session */}
                  {!isOriginal && (
                    <CloseOutlined sx={{ fontSize: 12, cursor: 'pointer', color: T.indigo[400], '&:hover': { color: T.rose[600] } }} onClick={() => remOpt(i)} />
                  )}
                </Box>
              );
            })}
            {row.mcqOptions.length === 0 && (
              <Typography sx={{ fontSize: 11, color: T.rose[600] }}>At least one option required</Typography>
            )}
          </Box>
        </Box>
      )}
    </Paper>
  );
};

/* ═══════════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════════════════ */
const FeedbackManager = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [feedbackType, setFeedbackType] = useState('');
  const [selectedFormForQuestions, setSelectedFormForQuestions] = useState(null);

  const [batches, setBatches] = useState([]);
  const [batchesLoading, setBatchesLoading] = useState(false);
  const [intakesMap, setIntakesMap] = useState({});
  const [intakesLoading, setIntakesLoading] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('create');
  const [editingFormId, setEditingFormId] = useState(null);
  const [rows, setRows] = useState([emptyQ()]);
  const [dlgBatchId, setDlgBatchId] = useState('');
  const [dlgIntakeId, setDlgIntakeId] = useState('');
  const [dlgModuleNumber, setDlgModuleNumber] = useState('');
  const [dlgModuleName, setDlgModuleName] = useState('');
  const [dlgTitle, setDlgTitle] = useState('');
  const [saving, setSaving] = useState(false);

  const [deleteDialog, setDeleteDialog] = useState({ open: false, form: null });
  const [deleting, setDeleting] = useState(false);

  const [feedbackForms, setFeedbackForms] = useState([]);
  const [formsLoading, setFormsLoading] = useState(false);

  const [selectedFormId, setSelectedFormId] = useState(null);
  const [responsesData, setResponsesData] = useState(null);
  const [rLoading, setRLoading] = useState(false);
  const [rError, setRError] = useState(null);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [rSearch, setRSearch] = useState('');
  const [formFilter, setFormFilter] = useState('ALL');

  const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });
  const showSnack = (m, s = 'success') => setSnack({ open: true, message: m, severity: s });

  const fetchBatches = useCallback(async () => {
    try {
      setBatchesLoading(true);
      const r = await axios.get('/batches');
      setBatches(r.data || []);
    } catch { showSnack('Failed to load batches', 'error'); }
    finally { setBatchesLoading(false); }
  }, []);

  const fetchIntakesForBatch = useCallback(async (batchId) => {
    if (!batchId || intakesMap[batchId]) return;
    try {
      setIntakesLoading(true);
      const r = await axios.get(`/intake-detail/batch/${batchId}`);
      setIntakesMap(prev => ({ ...prev, [batchId]: r.data || [] }));
    } catch { showSnack('Failed to load intakes', 'error'); }
    finally { setIntakesLoading(false); }
  }, [intakesMap]);

  const fetchFeedbackForms = useCallback(async () => {
    try {
      setFormsLoading(true);
      const r = await axios.get('/api/feedback/forms');
      const data = Array.isArray(r.data) ? r.data : (Array.isArray(r.data?.data) ? r.data.data : []);
      setFeedbackForms(data);
    } catch { setFeedbackForms([]); }
    finally { setFormsLoading(false); }
  }, []);

  useEffect(() => { fetchBatches(); fetchFeedbackForms(); }, [fetchBatches, fetchFeedbackForms]);
  useEffect(() => { if (activeTab === 1) fetchFeedbackForms(); }, [activeTab, fetchFeedbackForms]);
  useEffect(() => {
    if (feedbackForms.length > 0 && !selectedFormForQuestions)
      setSelectedFormForQuestions(feedbackForms[0]);
  }, [feedbackForms]);

  const updateRow = (key, field, value) =>
    setRows(prev => prev.map(r => r._key !== key ? r : { ...r, [field]: value }));

  const isRowValid = (r) => r.questionText.trim() && (r.questionType !== 'MCQ' || r.mcqOptions.length > 0);

  /* ── Open CREATE dialog ── */
  const openCreate = () => {
    setDialogMode('create');
    setEditingFormId(null);
    setRows([emptyQ()]);
    setFeedbackType('');
    setDlgTitle(''); setDlgBatchId(''); setDlgIntakeId('');
    setDlgModuleNumber(''); setDlgModuleName('');
    setDialogOpen(true);
  };

  /* ── Open EDIT dialog ── */
  const openEdit = (form) => {
    setDialogMode('edit');
    setEditingFormId(form.id);
    setDlgTitle(form.title || '');
    setFeedbackType(form.feedbackType || '');
    setDlgBatchId(form.batchId ? String(form.batchId) : '');
    setDlgIntakeId(form.intakeId || '');
    setDlgModuleNumber(form.moduleNumber ? String(form.moduleNumber) : '');
    setDlgModuleName(form.moduleName || '');

    // Mark existing questions as NOT new — they carry edit restrictions
    const existingRows = (form.questions || []).map((q) => {
      const opts = parseMcq(q.mcqOptions);
      return {
        _key: q.id || Math.random(),
        questionText: q.questionText || '',
        questionType: q.questionType || 'TEXT',
        required: q.required ?? true,
        mcqOptions: opts,
        _originalOptionCount: opts.length, // track how many options existed before edit
        _newOption: '',
        _isNew: false, // ← existing question: apply restrictions
      };
    });
    setRows(existingRows.length > 0 ? existingRows : [emptyQ()]);

    if (form.batchId) fetchIntakesForBatch(String(form.batchId));
    setDialogOpen(true);
  };

  const closeDialog = () => { setDialogOpen(false); setEditingFormId(null); setRows([emptyQ()]); };

  /* ── Save ── */
  const handleSubmit = async () => {
    setSaving(true);
    try {
      const payload = {
        title: dlgTitle || `Feedback - ${feedbackType}${dlgModuleName ? ' - ' + dlgModuleName : ''}`,
        feedbackType,
        batchId: dlgBatchId ? Number(dlgBatchId) : null,
        intakeId: dlgIntakeId || null,
        moduleNumber: dlgModuleNumber ? Number(dlgModuleNumber) : null,
        moduleName: dlgModuleName || null,
        questions: rows.map((r, i) => ({
          questionText: r.questionText,
          questionType: r.questionType,
          orderIndex: i + 1,
          required: r.required,
          mcqOptions: r.questionType === 'MCQ' ? r.mcqOptions : null,
        })),
      };

      if (dialogMode === 'edit') {
        await axios.put(`/api/feedback/form/update/${editingFormId}`, payload);
        showSnack('Feedback form updated successfully');
        if (selectedFormForQuestions?.id === editingFormId) setSelectedFormForQuestions(null);
      } else {
        await axios.post('/api/feedback/form', payload);
        showSnack(`Feedback form created with ${rows.length} question(s)`);
      }

      closeDialog();
      await fetchFeedbackForms();
    } catch (err) {
      showSnack(err?.response?.data?.message || 'Failed to save form', 'error');
    } finally {
      setSaving(false);
    }
  };

  /* ── Delete ── */
  const handleDeleteConfirm = async () => {
    if (!deleteDialog.form) return;
    setDeleting(true);
    try {
      await axios.delete(`/api/feedback/form/delete/${deleteDialog.form.id}`);
      showSnack('Feedback form deleted successfully');
      setDeleteDialog({ open: false, form: null });
      if (selectedFormForQuestions?.id === deleteDialog.form.id) setSelectedFormForQuestions(null);
      if (selectedFormId === deleteDialog.form.id) { setSelectedFormId(null); setResponsesData(null); }
      await fetchFeedbackForms();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data || 'Failed to delete form';
      showSnack(typeof msg === 'string' ? msg : 'Cannot delete — students have already submitted responses.', 'error');
      setDeleteDialog({ open: false, form: null });
    } finally {
      setDeleting(false);
    }
  };

  /* ── Load responses ── */
  const fetchFormResponses = useCallback(async (formId) => {
    setSelectedFormId(formId);
    setResponsesData(null); setRError(null); setRSearch('');
    setRLoading(true);
    try {
      const r = await axios.get(`/api/feedback/responses/${formId}`);
      setResponsesData(r.data);
    } catch (err) {
      setRError(err?.response?.data?.message || 'Failed to load responses');
    } finally { setRLoading(false); }
  }, []);

  /* ── Derived ── */
  const currentIntakes = useMemo(() =>
    dlgBatchId ? (intakesMap[dlgBatchId] || []) : [], [dlgBatchId, intakesMap]);

  const currentModules = useMemo(() => {
    if (!dlgIntakeId) {
      const batch = batches.find(b => String(b.id) === String(dlgBatchId));
      return batch?.moduleDetails || [];
    }
    const intake = currentIntakes.find(i => i.intakeId === dlgIntakeId);
    return intake?.moduleDetails || [];
  }, [dlgIntakeId, dlgBatchId, currentIntakes, batches]);

  const filteredForms = useMemo(() =>
    formFilter === 'ALL' ? feedbackForms : feedbackForms.filter(f => (f.feedbackType || f.type) === formFilter),
    [feedbackForms, formFilter]);

  const displayed = useMemo(() => {
    if (!responsesData?.responses) return [];
    const s = rSearch.toLowerCase();
    if (!s) return responsesData.responses;
    return responsesData.responses.filter(r =>
      r.studentName?.toLowerCase().includes(s) ||
      String(r.studentId).includes(s) ||
      r.intakeId?.toLowerCase().includes(s));
  }, [responsesData, rSearch]);

  const mcqAnalytics = useMemo(() => {
    if (!responsesData) return [];
    return (responsesData.questions || []).filter(q => q.questionType === 'MCQ').map(q => {
      const counts = {};
      (responsesData.responses || []).forEach(r => {
        const a = r.answers?.[q.questionId] || r.answers?.[String(q.questionId)];
        if (a) counts[a] = (counts[a] || 0) + 1;
      });
      return { ...q, counts, total: Object.values(counts).reduce((s, v) => s + v, 0) };
    });
  }, [responsesData]);

  const selectedForm = useMemo(() =>
    feedbackForms.find(f => f.id === selectedFormId), [feedbackForms, selectedFormId]);

  const stats = useMemo(() => ({
    forms: feedbackForms.length,
    module: feedbackForms.filter(f => f.feedbackType === 'MODULE').length,
    course: feedbackForms.filter(f => f.feedbackType === 'COURSE').length,
    alumni: feedbackForms.filter(f => f.feedbackType === 'ALUMNI').length,
  }), [feedbackForms]);

  const isSaveDisabled = !rows.every(isRowValid) || !feedbackType || saving;
  const isEditMode = dialogMode === 'edit';

  /* ─── RENDER ──────────────────────────────────────────────────────────── */
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: T.slate[50], fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
      <FontLink />
      <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 2, md: 3 }, py: 3 }}>

        {/* ── Page header ── */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 3, flexWrap: 'wrap', gap: 2 }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: .5 }}>
              <Box sx={{ width: 38, height: 38, borderRadius: '10px', bgcolor: T.indigo[600], display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FeedbackOutlined sx={{ color: 'white', fontSize: 18 }} />
              </Box>
              <Typography sx={{ fontSize: 22, fontWeight: 800, color: T.slate[900], letterSpacing: -.5, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                Feedback Manager
              </Typography>
            </Box>
            <Typography sx={{ fontSize: 13, color: T.slate[400], ml: .5 }}>
              Create · Edit · Delete feedback forms · View student responses
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {[
              { label: 'Total Forms', val: stats.forms,  c: T.indigo  },
              { label: 'Module',      val: stats.module, c: T.violet  },
              { label: 'Course',      val: stats.course, c: T.emerald },
              { label: 'Alumni',      val: stats.alumni, c: T.amber   },
            ].map(s => (
              <Box key={s.label} sx={{ px: 1.5, py: .75, borderRadius: '10px', bgcolor: s.c[50], border: `1px solid ${s.c[200]}`, textAlign: 'center', minWidth: 62 }}>
                <Typography sx={{ fontSize: 18, fontWeight: 800, color: s.c[600], lineHeight: 1 }}>{s.val}</Typography>
                <Typography sx={{ fontSize: 10, color: s.c[800], textTransform: 'uppercase', letterSpacing: .5 }}>{s.label}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* ── Tabs ── */}
        <Box sx={{ display: 'flex', gap: .5, mb: 2.5, borderBottom: `1px solid ${T.slate[200]}` }}>
          {['Feedback Forms', 'Student Responses'].map((label, i) => (
            <Box key={i} onClick={() => setActiveTab(i)} sx={{
              px: 2, py: 1.25, cursor: 'pointer', fontSize: 13.5, fontWeight: 700,
              color: activeTab === i ? T.indigo[600] : T.slate[500],
              borderBottom: activeTab === i ? `2.5px solid ${T.indigo[600]}` : '2.5px solid transparent',
              mb: '-1px', transition: 'all .15s', '&:hover': { color: T.indigo[600] },
            }}>
              {label}
              {feedbackForms.length > 0 && (
                <Box component="span" sx={{ ml: 1, px: .75, py: .125, borderRadius: '20px', fontSize: 10, fontWeight: 800, bgcolor: T.indigo[600], color: 'white' }}>
                  {feedbackForms.length}
                </Box>
              )}
            </Box>
          ))}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button variant="contained" startIcon={<Add />} onClick={openCreate}
            sx={{ textTransform: 'none', borderRadius: '8px', backgroundColor: T.indigo[600], boxShadow: 'none', fontFamily: 'Plus Jakarta Sans, sans-serif', '&:hover': { backgroundColor: T.indigo[800], boxShadow: 'none' } }}>
            Create Feedback Form
          </Button>
        </Box>

        {/* ═══ TAB 0 — FORMS & QUESTIONS ═══ */}
        {activeTab === 0 && (
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '320px 1fr' }, gap: 2 }}>
            <Paper elevation={0} sx={{ borderRadius: '12px', border: `1px solid ${T.slate[200]}`, p: 2, bgcolor: 'white' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 13, color: T.slate[800] }}>Feedback Forms</Typography>
                <IconButton size="small" onClick={fetchFeedbackForms} sx={{ p: .5 }}>
                  <Refresh sx={{ fontSize: 14, color: T.slate[400] }} />
                </IconButton>
              </Box>
              {formsLoading ? (
                <Stack spacing={1}>{[1,2,3].map(i => <Skeleton key={i} variant="rounded" height={56} sx={{ borderRadius: '8px' }} />)}</Stack>
              ) : feedbackForms.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <AssignmentOutlined sx={{ fontSize: 36, color: T.slate[200], mb: 1 }} />
                  <Typography sx={{ fontSize: 12, color: T.slate[400] }}>No forms yet</Typography>
                </Box>
              ) : (
                <Stack spacing={1}>
                  {feedbackForms.map(form => (
                    <Box key={form.id} onClick={() => setSelectedFormForQuestions(form)} sx={{
                      p: 1.5, borderRadius: '10px',
                      border: `1.5px solid ${selectedFormForQuestions?.id === form.id ? T.indigo[400] : T.slate[200]}`,
                      bgcolor: selectedFormForQuestions?.id === form.id ? T.indigo[50] : 'white',
                      cursor: 'pointer', transition: 'all .18s',
                      '&:hover': { borderColor: T.indigo[300] },
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.slate[800], mb: .5 }} noWrap>{form.title}</Typography>
                          <Box sx={{ display: 'flex', gap: .5, flexWrap: 'wrap' }}>
                            <TypePill type={form.feedbackType} />
                            {form.moduleNumber && (
                              <Box component="span" sx={{ display: 'inline-flex', px: 1, py: .125, borderRadius: '20px', fontSize: 10, fontWeight: 700, bgcolor: T.indigo[50], color: T.indigo[700], border: `1px solid ${T.indigo[200]}` }}>
                                Mod {form.moduleNumber}
                              </Box>
                            )}
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: .5, flexShrink: 0 }} onClick={e => e.stopPropagation()}>
                          <Tooltip title="Edit form">
                            <IconButton size="small" onClick={() => openEdit(form)} sx={{ p: .5, color: T.indigo[600], '&:hover': { bgcolor: T.indigo[50] } }}>
                              <Edit sx={{ fontSize: 14 }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete form">
                            <IconButton size="small" onClick={() => setDeleteDialog({ open: true, form })} sx={{ p: .5, color: T.rose[500], '&:hover': { bgcolor: T.rose[50] } }}>
                              <Delete sx={{ fontSize: 14 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Stack>
              )}
            </Paper>

            {!selectedFormForQuestions ? (
              <Box sx={{ textAlign: 'center', py: 10, borderRadius: '12px', border: `1px dashed ${T.slate[200]}`, bgcolor: 'white' }}>
                <AssignmentOutlined sx={{ fontSize: 48, color: T.slate[200], mb: 1.5 }} />
                <Typography sx={{ color: T.slate[500] }}>Select a form to view its questions</Typography>
              </Box>
            ) : (
              <Box>
                <Paper elevation={0} sx={{ borderRadius: '12px', border: `1px solid ${T.slate[200]}`, p: 2, mb: 2, bgcolor: 'white', background: `linear-gradient(135deg, ${T.indigo[50]} 0%, white 70%)` }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2 }}>
                    <Box>
                      <Typography sx={{ fontSize: 16, fontWeight: 800, color: T.slate[900], mb: .75 }}>{selectedFormForQuestions.title}</Typography>
                      <Box sx={{ display: 'flex', gap: .75, flexWrap: 'wrap' }}>
                        <TypePill type={selectedFormForQuestions.feedbackType} />
                        {selectedFormForQuestions.moduleNumber && (
                          <Box component="span" sx={{ display: 'inline-flex', px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 700, bgcolor: T.indigo[50], color: T.indigo[800], border: `1px solid ${T.indigo[200]}` }}>
                            Module {selectedFormForQuestions.moduleNumber}
                          </Box>
                        )}
                        {selectedFormForQuestions.intakeId && (
                          <Box component="span" sx={{ display: 'inline-flex', px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 600, bgcolor: T.slate[100], color: T.slate[600] }}>
                            {selectedFormForQuestions.intakeId}
                          </Box>
                        )}
                      </Box>
                    </Box>
                    <Button size="small" startIcon={<Edit sx={{ fontSize: 14 }} />} onClick={() => openEdit(selectedFormForQuestions)} variant="outlined"
                      sx={{ textTransform: 'none', fontSize: 12, borderRadius: '8px', borderColor: T.indigo[300], color: T.indigo[600], fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                      Edit Form
                    </Button>
                  </Box>
                </Paper>
                {(selectedFormForQuestions.questions || []).length === 0 ? (
                  <Box sx={{ textAlign: 'center', py: 6, borderRadius: '12px', border: `1px dashed ${T.slate[200]}`, bgcolor: 'white' }}>
                    <Typography sx={{ color: T.slate[400], fontSize: 13 }}>No questions in this form</Typography>
                  </Box>
                ) : (
                  <Stack spacing={1.5}>
                    {selectedFormForQuestions.questions.map((q, index) => (
                      <Paper key={q.id} elevation={0} sx={{ p: 2, border: `1px solid ${T.slate[200]}`, borderRadius: '10px', bgcolor: 'white' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                          <Box sx={{ minWidth: 26, height: 26, borderRadius: '8px', bgcolor: T.indigo[50], border: `1px solid ${T.indigo[200]}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 800, color: T.indigo[700], flexShrink: 0 }}>
                            {index + 1}
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: T.slate[800], mb: .75, lineHeight: 1.4 }}>{q.questionText}</Typography>
                            <Box sx={{ display: 'flex', gap: .75, flexWrap: 'wrap', mb: q.questionType === 'MCQ' ? 1 : 0 }}>
                              <QtPill type={q.questionType} />
                              {!q.required && (
                                <Box component="span" sx={{ display: 'inline-flex', px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 600, bgcolor: T.slate[100], color: T.slate[600] }}>Optional</Box>
                              )}
                            </Box>
                            {q.questionType === 'MCQ' && (
                              <Box sx={{ display: 'flex', gap: .5, flexWrap: 'wrap' }}>
                                {parseMcq(q.mcqOptions).map((opt, i) => (
                                  <Box key={i} sx={{ px: 1, py: .25, borderRadius: '6px', fontSize: 11, bgcolor: T.slate[100], color: T.slate[600] }}>{opt}</Box>
                                ))}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Paper>
                    ))}
                  </Stack>
                )}
              </Box>
            )}
          </Box>
        )}

        {/* ═══ TAB 1 — STUDENT RESPONSES ═══ */}
        {activeTab === 1 && (
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '320px 1fr' }, gap: 2, alignItems: 'start' }}>
            <Box>
              <Paper elevation={0} sx={{ borderRadius: '12px', border: `1px solid ${T.slate[200]}`, overflow: 'hidden', bgcolor: 'white' }}>
                <Box sx={{ p: 2, borderBottom: `1px solid ${T.slate[200]}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: .75 }}>
                    <FormatListBulletedOutlined sx={{ fontSize: 15, color: T.slate[400] }} />
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.slate[800] }}>Feedback Forms</Typography>
                  </Box>
                  <IconButton size="small" onClick={fetchFeedbackForms} sx={{ p: .5 }}>
                    <Refresh sx={{ fontSize: 14, color: T.slate[400] }} />
                  </IconButton>
                </Box>
                <Box sx={{ px: 1.5, pt: 1.5, pb: 1, display: 'flex', gap: .5, flexWrap: 'wrap' }}>
                  {['ALL', 'MODULE', 'COURSE', 'ALUMNI'].map(ft => (
                    <Box key={ft} onClick={() => setFormFilter(ft)} sx={{
                      px: 1.25, py: .375, borderRadius: '20px', fontSize: 11, fontWeight: 700, cursor: 'pointer',
                      bgcolor: formFilter === ft ? T.indigo[600] : T.slate[100],
                      color: formFilter === ft ? 'white' : T.slate[500],
                      transition: 'all .15s',
                    }}>
                      {ft === 'ALL' ? `All (${feedbackForms.length})` : `${ft} (${feedbackForms.filter(f => (f.feedbackType || f.type) === ft).length})`}
                    </Box>
                  ))}
                </Box>
                <Box sx={{ p: 1.5, maxHeight: 560, overflowY: 'auto' }}>
                  {formsLoading ? (
                    <Stack spacing={1}>{[1,2,3].map(i => <Skeleton key={i} variant="rounded" height={72} sx={{ borderRadius: '10px' }} />)}</Stack>
                  ) : filteredForms.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                      <AssignmentOutlined sx={{ fontSize: 36, color: T.slate[200], mb: 1 }} />
                      <Typography sx={{ fontSize: 12, color: T.slate[400] }}>No feedback forms found</Typography>
                    </Box>
                  ) : (
                    <Stack spacing={1}>
                      {filteredForms.map(form => (
                        <FeedbackFormCard key={form.id} form={form} isSelected={selectedFormId === form.id} onClick={() => fetchFormResponses(form.id)} />
                      ))}
                    </Stack>
                  )}
                </Box>
              </Paper>
            </Box>

            <Box>
              {!selectedFormId && !rLoading && (
                <Box sx={{ textAlign: 'center', py: 10, borderRadius: '12px', border: `1px dashed ${T.slate[200]}`, bgcolor: 'white' }}>
                  <PersonOutlined sx={{ fontSize: 48, color: T.slate[200], mb: 1.5 }} />
                  <Typography sx={{ fontSize: 15, fontWeight: 700, color: T.slate[700], mb: .5 }}>No form selected</Typography>
                  <Typography sx={{ fontSize: 13, color: T.slate[400] }}>Click a feedback form on the left to view student responses</Typography>
                </Box>
              )}
              {rLoading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}
              {rError && <Alert severity="error" sx={{ mb: 2, borderRadius: '10px', fontSize: 13 }}>{rError}</Alert>}

              {responsesData && selectedForm && (
                <>
                  <Paper elevation={0} sx={{ borderRadius: '12px', border: `1px solid ${T.slate[200]}`, p: 2, mb: 2, bgcolor: 'white', background: `linear-gradient(135deg, ${T.indigo[50]} 0%, white 70%)` }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2 }}>
                      <Box>
                        <Typography sx={{ fontSize: 16, fontWeight: 800, color: T.slate[900], mb: .75 }}>{selectedForm.title}</Typography>
                        <Box sx={{ display: 'flex', gap: .75, flexWrap: 'wrap' }}>
                          <TypePill type={selectedForm.feedbackType || selectedForm.type} />
                          {selectedForm.intakeId && (
                            <Box component="span" sx={{ display: 'inline-flex', px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 700, bgcolor: T.slate[100], color: T.slate[600] }}>
                              {selectedForm.intakeId}
                            </Box>
                          )}
                          {selectedForm.moduleNumber && (
                            <Box component="span" sx={{ display: 'inline-flex', px: 1, py: .25, borderRadius: '20px', fontSize: 11, fontWeight: 700, bgcolor: T.indigo[50], color: T.indigo[800], border: `1px solid ${T.indigo[200]}` }}>
                              Module {selectedForm.moduleNumber}{selectedForm.moduleName ? ` · ${selectedForm.moduleName}` : ''}
                            </Box>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ px: 2, py: 1, borderRadius: '10px', bgcolor: T.indigo[600], textAlign: 'center', minWidth: 64 }}>
                        <Typography sx={{ fontSize: 22, fontWeight: 800, color: 'white', lineHeight: 1 }}>{responsesData.responses?.length || 0}</Typography>
                        <Typography sx={{ fontSize: 10, color: 'rgba(255,255,255,0.75)', textTransform: 'uppercase', letterSpacing: .5 }}>Responses</Typography>
                      </Box>
                    </Box>
                  </Paper>

                  {responsesData.questions?.length > 0 && (
                    <Paper elevation={0} sx={{ borderRadius: '12px', border: `1px solid ${T.slate[200]}`, p: 2, mb: 2, bgcolor: 'white' }}>
                      <SectionLabel icon={FormatListBulletedOutlined}>Questions in this form</SectionLabel>
                      <Stack spacing={.75}>
                        {responsesData.questions.map((q, i) => (
                          <Box key={q.questionId} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                            <Typography sx={{ fontSize: 11, fontWeight: 800, color: T.slate[400], minWidth: 20, mt: .2 }}>Q{i + 1}</Typography>
                            <QtPill type={q.questionType} />
                            <Typography sx={{ fontSize: 12.5, color: T.slate[600], lineHeight: 1.5 }}>
                              {q.questionText}
                              {parseMcq(q.mcqOptions).length > 0 && (
                                <Typography component="span" sx={{ ml: 1, fontSize: 11, color: T.slate[400] }}>
                                  ({parseMcq(q.mcqOptions).join(' · ')})
                                </Typography>
                              )}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Paper>
                  )}

                  {mcqAnalytics.length > 0 && (
                    <Paper elevation={0} sx={{ borderRadius: '12px', border: `1px solid ${T.slate[200]}`, p: 2, mb: 2, bgcolor: 'white' }}>
                      <SectionLabel icon={BarChartOutlined}>MCQ Analytics</SectionLabel>
                      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
                        {mcqAnalytics.map(q => (
                          <Box key={q.questionId} sx={{ p: 2, borderRadius: '10px', border: `1px solid ${T.slate[200]}`, bgcolor: T.slate[50] }}>
                            <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.slate[800], mb: 1.5 }}>{q.questionText}</Typography>
                            {Object.entries(q.counts).map(([opt, cnt]) => (
                              <McqBar key={opt} label={opt} count={cnt} total={q.total} />
                            ))}
                            <Typography sx={{ fontSize: 11, color: T.slate[400], mt: 1 }}>{q.total} total responses</Typography>
                          </Box>
                        ))}
                      </Box>
                    </Paper>
                  )}

                  <Box sx={{ display: 'flex', gap: 1, mb: 1.5, alignItems: 'center' }}>
                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', px: 1.5, py: .375, borderRadius: '20px', fontSize: 12, fontWeight: 700, bgcolor: T.slate[100], color: T.slate[600], border: `1px solid ${T.slate[200]}` }}>
                      {displayed.length} of {responsesData.responses?.length || 0} responses
                    </Box>
                    <Box sx={{ flex: 1 }} />
                    <TextField size="small" placeholder="Search by name or ID…" value={rSearch}
                      onChange={e => setRSearch(e.target.value)}
                      InputProps={{ startAdornment: <InputAdornment position="start"><SearchOutlined sx={{ fontSize: 15, color: T.slate[400] }} /></InputAdornment>, sx: { borderRadius: '8px', fontSize: 13, bgcolor: 'white' } }}
                      sx={{ width: 210 }} />
                  </Box>

                  {displayed.length === 0 ? (
                    <Alert severity="info" sx={{ borderRadius: '10px' }}>No responses match your search.</Alert>
                  ) : (
                    <Paper elevation={0} sx={{ borderRadius: '12px', border: `1px solid ${T.slate[200]}`, overflow: 'hidden' }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ bgcolor: T.slate[50] }}>
                            {['Student', 'Student ID', 'Intake', 'Batch', 'Submitted', ''].map(h => (
                              <TableCell key={h} sx={{ fontWeight: 700, fontSize: 11, color: T.slate[400], textTransform: 'uppercase', letterSpacing: .6, py: 1.25, borderBottom: `1px solid ${T.slate[200]}` }}>{h}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayed.map(entry => (
                            <TableRow key={entry.studentFeedbackId} hover sx={{ cursor: 'pointer', '&:hover': { bgcolor: T.indigo[50] }, '&:last-child td': { border: 0 } }} onClick={() => setSelectedEntry(entry)}>
                              <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                  <Avatar sx={{ width: 30, height: 30, bgcolor: avatarBg(entry.studentName), fontSize: 11, fontWeight: 800 }}>{initials(entry.studentName)}</Avatar>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.slate[800] }}>{entry.studentName}</Typography>
                                </Box>
                              </TableCell>
                              <TableCell sx={{ fontSize: 12, color: T.slate[400] }}>{entry.studentId}</TableCell>
                              <TableCell sx={{ fontSize: 12, color: T.slate[600] }}>{entry.intakeId || '—'}</TableCell>
                              <TableCell sx={{ fontSize: 12, color: T.slate[600] }}>{entry.batchId || '—'}</TableCell>
                              <TableCell sx={{ fontSize: 12, color: T.slate[400], whiteSpace: 'nowrap' }}>{fmtDate(entry.submittedAt)}</TableCell>
                              <TableCell align="right">
                                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: .5, px: 1.5, py: .375, borderRadius: '8px', fontSize: 11, fontWeight: 700, bgcolor: T.indigo[50], color: T.indigo[700], border: `1px solid ${T.indigo[200]}` }}>
                                  <VisibilityOutlined sx={{ fontSize: 12 }} />View
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Paper>
                  )}
                </>
              )}
            </Box>
          </Box>
        )}
      </Box>

      {selectedEntry && (
        <ResponsePanel entry={selectedEntry} questions={responsesData?.questions} feedbackType={responsesData?.feedbackType} onClose={() => setSelectedEntry(null)} />
      )}

      {/* ═══ CREATE / EDIT DIALOG ═══ */}
      <Dialog open={dialogOpen} onClose={closeDialog} fullWidth maxWidth="md"
        PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden', fontFamily: 'Plus Jakarta Sans, sans-serif' } }}>

        <DialogTitle sx={{
          background: isEditMode
            ? `linear-gradient(135deg, ${T.amber[600]} 0%, ${T.amber[800]} 100%)`
            : `linear-gradient(135deg, ${T.indigo[600]} 0%, ${T.indigo[800]} 100%)`,
          color: 'white', py: 2.5, px: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <Box>
            <Typography sx={{ fontWeight: 800, fontSize: 16, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              {isEditMode ? 'Edit Feedback Form' : 'Create Feedback Form'}
            </Typography>
            <Typography sx={{ fontSize: 12, opacity: .75, mt: .25, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              {isEditMode
                ? 'You can edit the form title and questions. Type & feedback type are locked.'
                : `${rows.length} question(s) · select type to begin`}
            </Typography>
          </Box>
          <IconButton size="small" onClick={closeDialog} sx={{ color: 'white', opacity: .7, '&:hover': { opacity: 1 } }}>
            <CloseOutlined fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ py: 3, px: 3, bgcolor: T.slate[50] }}>
          <Stack spacing={2.5}>

            {/* Form Context */}
            <Paper elevation={0} sx={{ p: 2.5, borderRadius: '12px', border: `1px solid ${T.slate[200]}`, bgcolor: 'white' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <LayersOutlined sx={{ fontSize: 16, color: T.indigo[600] }} />
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.slate[800] }}>Form Details</Typography>
                {feedbackType && <Box sx={{ ml: 'auto' }}><TypePill type={feedbackType} /></Box>}
              </Box>

              {/* Title — always editable */}
              <TextField size="small" label="Form Title" value={dlgTitle}
                onChange={e => setDlgTitle(e.target.value)}
                placeholder="e.g. Module 2 Feedback - Jan 2025" fullWidth
                sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: 13, bgcolor: T.slate[50] } }} />

              {/* Feedback Type — locked in edit mode */}
              {isEditMode ? (
                <Box sx={{ mb: 2, p: 1.5, borderRadius: '8px', bgcolor: T.amber[50], border: `1px solid ${T.amber[200]}`, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <LockOutlined sx={{ fontSize: 16, color: T.amber[600] }} />
                  <Box>
                    <Typography sx={{ fontSize: 11, color: T.amber[700], fontWeight: 700, textTransform: 'uppercase', letterSpacing: .5 }}>Feedback Type (locked)</Typography>
                    <Box sx={{ mt: .5 }}><TypePill type={feedbackType} /></Box>
                  </Box>
                </Box>
              ) : (
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                  <InputLabel sx={{ fontSize: 13 }}>Feedback Type *</InputLabel>
                  <Select label="Feedback Type *" value={feedbackType}
                    onChange={e => { setFeedbackType(e.target.value); setDlgBatchId(''); setDlgIntakeId(''); setDlgModuleNumber(''); setDlgModuleName(''); }}
                    sx={{ borderRadius: '8px', fontSize: 13, bgcolor: T.slate[50] }}>
                    <MenuItem value="MODULE" sx={{ fontSize: 13 }}>Module</MenuItem>
                    <MenuItem value="COURSE" sx={{ fontSize: 13 }}>Course</MenuItem>
                    <MenuItem value="ALUMNI" sx={{ fontSize: 13 }}>Alumni</MenuItem>
                  </Select>
                </FormControl>
              )}

              {/* Batch/Module selectors — only in create mode */}
              {!isEditMode && (feedbackType === 'MODULE' || feedbackType === 'COURSE') && (
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: feedbackType === 'MODULE' ? '1fr 1fr 1fr' : '1fr' }, gap: 1.5 }}>
                  <FormControl size="small" fullWidth>
                    <InputLabel sx={{ fontSize: 13 }}>Batch</InputLabel>
                    <Select label="Batch" value={dlgBatchId}
                      onChange={e => { const v = e.target.value; setDlgBatchId(v); setDlgIntakeId(''); setDlgModuleNumber(''); setDlgModuleName(''); if (v) fetchIntakesForBatch(v); }}
                      sx={{ borderRadius: '8px', fontSize: 13, bgcolor: T.slate[50] }} displayEmpty>
                      <MenuItem value=""><em style={{ color: T.slate[400] }}>Select a batch</em></MenuItem>
                      {batchesLoading
                        ? <MenuItem disabled><CircularProgress size={12} /> Loading…</MenuItem>
                        : batches.map(b => (
                          <MenuItem key={b.id} value={String(b.id)} sx={{ fontSize: 13 }}>
                            <Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{b.batchcode || b.course}</Typography>
                              <Typography sx={{ fontSize: 11, color: T.slate[400] }}>ID: {b.id} · {b.type || '—'}</Typography>
                            </Box>
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                  {feedbackType === 'MODULE' && (
                    <FormControl size="small" fullWidth disabled={!dlgBatchId}>
                      <InputLabel sx={{ fontSize: 13 }}>Intake</InputLabel>
                      <Select label="Intake" value={dlgIntakeId}
                        onChange={e => { setDlgIntakeId(e.target.value); setDlgModuleNumber(''); setDlgModuleName(''); }}
                        sx={{ borderRadius: '8px', fontSize: 13, bgcolor: T.slate[50] }} displayEmpty>
                        <MenuItem value=""><em style={{ color: T.slate[400] }}>Select an intake</em></MenuItem>
                        {intakesLoading ? <MenuItem disabled><CircularProgress size={12} /> Loading…</MenuItem>
                          : currentIntakes.map(intake => (
                            <MenuItem key={intake.intakeId} value={intake.intakeId} sx={{ fontSize: 13 }}>
                              <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{intake.intakeId}</Typography>
                            </MenuItem>
                          ))
                        }
                      </Select>
                    </FormControl>
                  )}
                  {feedbackType === 'MODULE' && (
                    <FormControl size="small" fullWidth disabled={!dlgBatchId}>
                      <InputLabel sx={{ fontSize: 13 }}>Module</InputLabel>
                      <Select label="Module" value={dlgModuleNumber}
                        onChange={e => {
                          const v = e.target.value; setDlgModuleNumber(v);
                          if (v) { const mod = currentModules.find(m => String(m.id) === String(v)); setDlgModuleName(mod?.moduleName || ''); }
                          else setDlgModuleName('');
                        }}
                        sx={{ borderRadius: '8px', fontSize: 13, bgcolor: T.slate[50] }} displayEmpty>
                        <MenuItem value=""><em style={{ color: T.slate[400] }}>Select a module</em></MenuItem>
                        {currentModules.map((mod, idx) => (
                          <MenuItem key={mod.id} value={String(idx + 1)} sx={{ fontSize: 13 }}>
                            <Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 600 }}>Module {idx + 1}</Typography>
                              <Typography sx={{ fontSize: 11, color: T.slate[400] }}>{mod.moduleName}</Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </Box>
              )}

              {feedbackType && !isEditMode && (
                <Box sx={{
                  mt: 1.5, p: 1.25, borderRadius: '8px',
                  bgcolor: feedbackType === 'MODULE' ? T.indigo[50] : feedbackType === 'COURSE' ? T.emerald[50] : T.amber[50],
                  border: `1px solid ${feedbackType === 'MODULE' ? T.indigo[200] : feedbackType === 'COURSE' ? T.emerald[200] : T.amber[200]}`,
                  display: 'flex', alignItems: 'center', gap: 1,
                }}>
                  <CheckCircleOutlined sx={{ fontSize: 14, color: feedbackType === 'MODULE' ? T.indigo[600] : feedbackType === 'COURSE' ? T.emerald[600] : T.amber[600] }} />
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: feedbackType === 'MODULE' ? T.indigo[800] : feedbackType === 'COURSE' ? T.emerald[800] : T.amber[800] }}>
                    {feedbackType === 'MODULE' && `Module feedback${dlgModuleNumber ? ` · Module ${dlgModuleNumber}${dlgModuleName ? ` (${dlgModuleName})` : ''}` : ' — select batch and module above'}`}
                    {feedbackType === 'COURSE' && `Course feedback${dlgBatchId ? ` · selected batch` : ' — select batch above'}`}
                    {feedbackType === 'ALUMNI' && 'Alumni feedback — no batch or module required'}
                  </Typography>
                </Box>
              )}
            </Paper>

            {/* Edit mode notice */}
            {isEditMode && (
              <Box sx={{ p: 1.5, borderRadius: '10px', bgcolor: T.amber[50], border: `1px solid ${T.amber[200]}`, display: 'flex', gap: 1.5 }}>
                <LockOutlined sx={{ fontSize: 16, color: T.amber[600], flexShrink: 0, mt: .2 }} />
                <Box>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.amber[800] }}>Edit restrictions active</Typography>
                  <Typography sx={{ fontSize: 11.5, color: T.amber[700], mt: .25, lineHeight: 1.5 }}>
                    Existing questions: question type is locked · MCQ existing options cannot be removed · you can edit question text, toggle required, and add new MCQ options.
                    New questions you add below have no restrictions.
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Questions */}
            <Stack spacing={2}>
              {rows.map((row, idx) => (
                <QuestionRow
                  key={row._key}
                  row={row}
                  index={idx}
                  onUpdate={updateRow}
                  onRemove={(key) => setRows(p => p.filter(r => r._key !== key))}
                  showRemove={rows.length > 1}
                  isEditMode={isEditMode}
                />
              ))}
            </Stack>

            <Button
              startIcon={<AddCircleOutline sx={{ fontSize: 16 }} />}
              onClick={() => setRows(p => [...p, emptyQ()])}
              sx={{ textTransform: 'none', fontSize: 13, color: T.indigo[600], fontFamily: 'Plus Jakarta Sans, sans-serif', alignSelf: 'flex-start', '&:hover': { bgcolor: T.indigo[50] } }}>
              Add another question
            </Button>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${T.slate[200]}`, bgcolor: 'white', justifyContent: 'space-between' }}>
          <Typography sx={{ fontSize: 12, color: T.slate[400] }}>
            {`${rows.length} question(s) · ${feedbackType || 'No type selected'}`}
          </Typography>
          <Stack direction="row" spacing={1}>
            <Button onClick={closeDialog} variant="outlined" size="small"
              sx={{ borderRadius: '8px', textTransform: 'none', fontSize: 13, borderColor: T.slate[200], color: T.slate[500], fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained" size="small" disabled={isSaveDisabled}
              startIcon={saving ? <CircularProgress size={14} sx={{ color: 'white' }} /> : <SaveOutlined sx={{ fontSize: 15 }} />}
              sx={{
                borderRadius: '8px', textTransform: 'none', fontSize: 13, fontWeight: 800,
                bgcolor: isEditMode ? T.amber[600] : T.indigo[600],
                boxShadow: 'none', px: 2.5, fontFamily: 'Plus Jakarta Sans, sans-serif',
                '&:hover': { bgcolor: isEditMode ? T.amber[800] : T.indigo[800], boxShadow: 'none' },
              }}>
              {saving ? 'Saving…' : isEditMode ? 'Update Form' : 'Save Form'}
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      <DeleteConfirmDialog
        open={deleteDialog.open}
        formTitle={deleteDialog.form?.title}
        onConfirm={handleDeleteConfirm}
        onCancel={() => setDeleteDialog({ open: false, form: null })}
        loading={deleting}
      />

      <Snackbar open={snack.open} autoHideDuration={3000} onClose={() => setSnack(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity={snack.severity} variant="filled" sx={{ borderRadius: '10px', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default FeedbackManager;